import { render } from "./Hero.vue?vue&type=template&id=5c2f5a04"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
script.render = render

export default script